<template>
  <div>
  <b-row>
    <!-- statistics -->
    <b-col md="12">
      <b-card
        v-if="statisticsItems"
        no-body
        class="statistics"
      >
        <b-card-header>
          <b-card-title>{{$t('Statistics')}}</b-card-title>
          <b-card-text class="font-small-2 mr-25 mb-0">
            آخر تحديث منذ 12 دقيقة
          </b-card-text>
        </b-card-header>
        <b-card-body class="statistics-body">
          <b-row>
            <b-col
              md="3" 
            >
              <b-media no-body>
                <b-media-aside

                  class="mr-2"
                >
                  <b-avatar
                    size="48"
                    variant="light-warning"
                  >
                    <feather-icon
                      size="24"
                      icon="AlertOctagonIcon"
                    />
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto">
                  <h4 class="font-weight-bolder mb-0">
                    9040 {{$t('SAR')}}
                  </h4>
                  <b-card-text class="font-small-3 mb-0">
                    المبالغ المعلقة
                  </b-card-text>
                </b-media-body>
              </b-media>
            </b-col>
            <b-col
              md="3" 
            >
              <b-media no-body>
                <b-media-aside

                  class="mr-2"
                >
                  <b-avatar
                    size="48"
                    variant="light-secondary"
                  >
                    <feather-icon
                      size="24"
                      icon="ActivityIcon"
                    />
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto">
                  <h4 class="font-weight-bolder mb-0">
                    203
                  </h4>
                  <b-card-text class="font-small-3 mb-0">
                    عدد العمليات اليوم
                  </b-card-text>
                </b-media-body>
              </b-media>
            </b-col>
            <b-col
              md="3" 
            >
              <b-media no-body>
                <b-media-aside

                  class="mr-2"
                >
                  <b-avatar
                    size="48"
                    variant="light-primary"
                  >
                    <feather-icon
                      size="24"
                      icon="TrendingUpIcon"
                    />
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto">
                  <h4 class="font-weight-bolder mb-0">
                    23039 {{$t('SAR')}}
                  </h4>
                  <b-card-text class="font-small-3 mb-0">
                    مبيعات اليوم
                  </b-card-text>
                </b-media-body>
              </b-media>
            </b-col>
          
            <b-col
              md="3" 
            >
              <b-media no-body>
                <b-media-aside

                  class="mr-2"
                >
                  <b-avatar
                    size="48"
                    variant="light-success"
                  >
                    <feather-icon
                      size="24"
                      icon="TrendingUpIcon"
                    />
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto">
                  <h4 class="font-weight-bolder mb-0">
                    204588 {{$t('SAR')}}
                  </h4>
                  <b-card-text class="font-small-3 mb-0">
                    {{ $t('Month Sales') }}
                  </b-card-text>
                </b-media-body>
              </b-media>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
  <b-row>
    <!-- Goal -->
    <b-col
      lg="12"
      md="12" 
    >
      <!-- Orders Last 10 days -->
      <b-card title="طلبات آخر 30 يوم">
        <!-- <div class="d-flex justify-content-between flex-wrap">
          <div class="mb-1 mb-sm-0">
            <span class="text-muted">Commercial networks and enterprises</span>
          </div>
          <div class="d-flex align-content-center mb-1 mb-sm-0">
            <h1 class="font-weight-bolder ">
              $ 183,382
            </h1>
            <div class="pt-25 ml-75">
              <b-badge variant="light-secondary">
                <feather-icon
                  icon="ArrowDownIcon"
                  size="12"
                  class="text-danger align-middle"
                />
                <span class="font-weight-bolder align-middle"> 24%</span>
              </b-badge>
            </div>
          </div>
        </div> -->

        <!-- echart -->
        <app-echart-line :option-data="ordersLast10DaysData" />

      </b-card>
    </b-col>
    
  </b-row>
  

  <b-row>
    <b-col
      lg="12"
      md="12" 
    >
      <!-- Orders -->
      <b-card
      no-body
      >
        <b-card-header>
          <b-card-title class="ml-25">
            آخر العمليات
          </b-card-title>
        </b-card-header>

        <b-card-body>
          <template>
            <b-row>
              <b-col md="3">
                <b-card-title>
                  <b-link>منال</b-link><br>
                  <small>203810195454</small>
                </b-card-title>
              </b-col>
              <b-col md="3">
                <h3 class="text-success">333 {{$t('SAR')}}</h3>
              </b-col>
              <b-col md="3">
                منذ 22 دقيقة
              </b-col>
              <b-col md="3">
                <b-button 
                  size="sm"
                  variant="outline-primary"
                  class="mr-1"
                  v-b-tooltip.hover.top="'عرض'"
                >
                  <feather-icon
                      size="15"
                      icon="EyeIcon"
                    />
                </b-button>
                <b-button 
                  size="sm"
                  variant="outline-danger"
                  v-b-tooltip.hover.top="'استرداد'"
                >
                  <feather-icon
                      size="15"
                      icon="RotateCwIcon"
                    />
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <b-card-title>
                  <b-link>عبدالعزيز</b-link><br>
                  <small>203810195454</small>
                </b-card-title>
              </b-col>
              <b-col md="3">
                <h3 class="text-success">56 {{$t('SAR')}}</h3>
              </b-col>
              <b-col md="3">
                منذ 35 دقيقة
              </b-col>
              <b-col md="3">
                <b-button 
                  size="sm"
                  variant="outline-primary"
                  class="mr-1"
                  v-b-tooltip.hover.top="'عرض'"
                >
                  <feather-icon
                      size="15"
                      icon="EyeIcon"
                    />
                </b-button>
                <b-button 
                  size="sm"
                  variant="outline-danger"
                  v-b-tooltip.hover.top="'استرداد'"
                >
                  <feather-icon
                      size="15"
                      icon="RotateCwIcon"
                    />
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <b-card-title>
                  <b-link>عبدالرحمن</b-link><br>
                  <small>203810195454</small>
                </b-card-title>
              </b-col>
              <b-col md="3">
                <h3 class="text-success">109 {{$t('SAR')}}</h3>
              </b-col>
              <b-col md="3">
                منذ 44 دقيقة
              </b-col>
              <b-col md="3">
                <b-button 
                  size="sm"
                  variant="outline-primary"
                  class="mr-1"
                  v-b-tooltip.hover.top="'عرض'"
                >
                  <feather-icon
                      size="15"
                      icon="EyeIcon"
                    />
                </b-button>
                <b-button 
                  size="sm"
                  variant="outline-danger"
                  v-b-tooltip.hover.top="'استرداد'"
                >
                  <feather-icon
                      size="15"
                      icon="RotateCwIcon"
                    />
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <b-card-title>
                  <b-link>فهد</b-link><br>
                  <small>203810195454</small>
                </b-card-title>
              </b-col>
              <b-col md="3">
                <h3 class="text-success">236 {{$t('SAR')}}</h3>
              </b-col>
              <b-col md="3">
                منذ 1 ساعة
              </b-col>
              <b-col md="3">
                <b-button 
                  size="sm"
                  variant="outline-primary"
                  class="mr-1"
                  v-b-tooltip.hover.top="'عرض'"
                >
                  <feather-icon
                      size="15"
                      icon="EyeIcon"
                    />
                </b-button>
                <b-button 
                  size="sm"
                  variant="outline-danger"
                  v-b-tooltip.hover.top="'استرداد'"
                >
                  <feather-icon
                      size="15"
                      icon="RotateCwIcon"
                    />
                </b-button>
              </b-col>
            </b-row>
          </template>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
  <b-row>
    <b-col
      lg="12"
      md="12" 
      class="mb-2"
    >
      <img src="https://cdn.mhd.sa/asset/images/providers/Moyasar-logo.png" height="40" />
      <small>خدمة الدفع الإلكتروني مقدمة من ميسّر </small>
    </b-col>
  </b-row>
  </div>
</template>

<script>
import AppEchartLine from '@core/components/charts/echart/AppEchartLine.vue'
import VueApexCharts from 'vue-apexcharts'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

const $strokeColor = '#ebe9f1'
const $textHeadingColor = '#5e5873'
const $goalStrokeColor2 = '#51e5a8'
export default {
  components: {
    AppEchartLine,
    VueApexCharts,
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      ordersLast10DaysData: {
        xAxisData: ['7/12', '8/12', '9/12', '10/12', '11/12', '12/12', '13/12', '14/12', '15/12', '16/12','17/12', '18/12', '19/12', '20/12', '21/12', '22/12', '23/12', '24/12', '25/12', '26/12','27/12', '28/12', '29/12', '30/12', '31/12', '01/01', '02/01', '03/01', '04/01', '05/01'],
        series: ['290', '200', '210', '190', '250', '220', '80', '90', '200', '150', '160','290', '200', '210', '190', '250', '220', '80', '90', '200', '150', '160', '200', '210', '190', '250', '220', '80', '90', '200', '150', '160'],
      },
      goalOverviewRadialBar: {
        data: {
          completed: '786,617',
          inProgress: '13,561',
          series: [83],
        },
        chart: {
          height: 245,
          type: 'radialBar',
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [$goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: '77%',
            },
            track: {
              background: $strokeColor,
              strokeWidth: '50%',
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                color: $textHeadingColor,
                fontSize: '2.86rem',
                fontWeight: '600',
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#28c76f'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
      statisticsItems: [
        {
          icon: 'TrendingUpIcon',
          color: 'light-primary',
          title: '230k',
          subtitle: this.$t('Today Sales'),
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'UserIcon',
          color: 'light-info',
          title: '23',
          subtitle: this.$t('Today Sales Counts'),
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'BoxIcon',
          color: 'light-danger',
          title: '1.423k',
          subtitle: this.$t('Month Sales'),
          customClass: 'mb-2 mb-sm-0',
        },
        {
          icon: 'DollarSignIcon',
          color: 'light-success',
          title: '234',
          subtitle: this.$t('Month Sales Count'),
          customClass: '',
        },
      ],
      timeline: {
        step1: {
          title: 'بدأ فهد عملية الشراء',
          img: require('@/assets/images/icons/json.png'),
          fileName: 'data.json',
          duration: 'مند 12 دقيقة',
        },
        step2: {
          title: 'أضاف زائر منتج إلى السلة',
          // subtitle: 'Project meeting with john @10:15am',
          avatar: 'https://cdn.mhd.sa/staging/mhd/24/40fa03d9240dad569bdd5c21a246a3ad511838.png',
          avatarName: 'آيفون برو 12',
          // occupation: 'CEO of Infibeam',
          duration: 'منذ 25 دقيقة',
        },
        step3: {
          title: 'طلب جديد بواسطة علي أحمد',
          subtitle: 'رقم الطلب #44352',
          duration: 'منذ 45 دقيقة',
          // avatars: [
          //   { userImg: require('@/assets/images/portrait/small/avatar-s-9.jpg'), name: 'Billy Hopkins' },
          //   { userImg: require('@/assets/images/portrait/small/avatar-s-6.jpg'), name: 'Amy Carson' },
          //   { userImg: require('@/assets/images/portrait/small/avatar-s-8.jpg'), name: 'Brandon Miles' },
          //   { userImg: require('@/assets/images/portrait/small/avatar-s-7.jpg'), name: 'Daisy Weber' },
          //   { userImg: require('@/assets/images/portrait/small/avatar-s-20.jpg'), name: 'Jenny Looper' },
          // ],
        },
        step4: {
          title: 'بدأ علي أحمد عملية الشراء',
          duration: 'منذ 1 ساعة',
          // subtitle: 'Add files to new design folder',
        },
      },
    }
  },
}
</script>

<style>

</style>
